import { render, staticRenderFns } from "./RestaurantSettingsDialog.vue?vue&type=template&id=30c5291a&scoped=true"
import script from "./RestaurantSettingsDialog.vue?vue&type=script&lang=js"
export * from "./RestaurantSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./RestaurantSettingsDialog.vue?vue&type=style&index=0&id=30c5291a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c5291a",
  null
  
)

export default component.exports